import { EColors } from 'common/styles'
import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
const fadeInFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-30px) translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0) scale(1);
  }
`

const fadeInFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px) translateY(30px) rotateY(180deg) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0) rotateY(180deg) scale(1);
  }
`
export const Dragonfly = styled.img`
  position: absolute;
  top: 10px;
  left: 20px;
  width: 47px;
  opacity: 0;
  animation: ${fadeInFromLeft} 0.8s ease-out 0.2s forwards;
  will-change: opacity, transform;

  @media screen and (min-width: 768px) {
    top: 0px;
    left: 8px;
    width: 57px;
  }

  @media screen and (min-width: 1000px) {
    top: -2px;
    left: 8px;
  }

  @media screen and (min-width: 1200px) {
    top: 30px;
    left: 88px;
    width: 87px;
  }
`
export const DragonflyRight = styled.img`
  position: absolute;
  top: 78px;
  right: 45px;
  width: 47px;
  transform: rotateY(180deg);
  opacity: 0;
  animation: ${fadeInFromRight} 0.8s ease-out 0.4s forwards;

  @media screen and (min-width: 768px) {
    top: 60px;
    right: 36%;
    width: 57px;
  }

  @media screen and (min-width: 1200px) {
    top: 120px;
    right: 24%;
    width: 87px;
  }

  @media screen and (min-width: 1440px) {
    top: 120px;
    right: 35%;
  }
`
export const AnimatedImage = styled.img<{ $delay?: number }>`
  opacity: 0;
  animation: ${fadeInUp} 0.5s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay || 0}s;
  width: 100%;
  object-fit: cover;
`
export const ContantContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 72px;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: 1199px) {
    padding: 0 16px;
  }
`

export const Container = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: ${EColors.bg_light};
`

export const TitleWrapper = styled.div`
  opacity: 0;
  transform: translateY(-100%);
  animation: appearence 0.4s ease-out 0.2s forwards;

  @keyframes appearence {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Title = styled.h2`
  font-size: 28px;
  margin-top: 60px;
  margin-bottom: 50px;
  font-weight: 500;
  color: ${EColors.primary_500};
  font-family: 'playfair Display';
  @media (min-width: 768px) {
    font-size: 38px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
    margin-top: 25px;
    margin-left: 40px;
  }
  @media (min-width: 1200px) {
    font-size: 68px;
    margin-top: 90px;
    margin-left: 60px;
  }
`

export const MobileImagesWrap = styled.div<{ $count?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  img {
    width: 100%;
    object-fit: cover;
  }

  img:nth-child(1),
  img:nth-child(2) {
    height: 260px;
    width: calc(50% - 6px);
  }

  ${({ $count }) =>
    $count === 3 &&
    `
    img:nth-child(3) {
      height: 190px;
    }
  `}

  @media (min-width: 768px) {
    display: none;
  }
`

export const LinksList = styled.div`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 50px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;

  a {
    text-decoration: none;
    color: ${EColors.primary_500};
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    max-width: 200px;
    position: relative;

    &.phone {
      height: 40px;
      padding: 0 14px;
      width: auto;
      flex: 1;
      min-width: 0;
      white-space: nowrap;

      &:after {
        transition:
          color 0.3s,
          background-color 0.3s;
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid ${EColors.primary_500};
        border-radius: 80% / 80%;
        transform: rotate(-2.7deg);
        pointer-events: none;
      }
    }
  }

  @media (min-width: 768px) {
    width: 420px;
    margin-top: 5px;

    a {
      font-size: 16px;
    }
  }

  @media (min-width: 1000px) {
    margin-bottom: 4px;
  }

  @media (min-width: 1200px) {
    .phone {
      width: auto;
      flex: 1;
    }
  }
`

export const MobileTextDescription = styled.p`
  font-size: 14px;
  line-height: 1.47;
  color: ${EColors.neutral_800};
  font-family: 'Montserrat', sans-serif;
  white-space: pre-wrap;
  @media (min-width: 768px) {
    display: none;
  }
`
export const DesktopWrap = styled.div`
  display: none;
  max-width: 1440px;
  margin: 0 auto;
  @media (min-width: 768px) {
    display: flex;
    gap: 12px;
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
`
export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  img {
    width: 100%;
  }

  @media (min-width: 1000px) {
    &:nth-child(1) {
      img {
        max-height: 385px;
      }
    }
    &:nth-child(2) {
      img {
        max-height: 680px;
      }
    }
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
  p {
    font-size: 18px;
    line-height: 26px;
    color: ${EColors.neutral_800};
    font-family: 'Montserrat', sans-serif;
    white-space: pre-wrap;
  }
`
